import React from "react"
import classnames from "classnames"
import { WINDOW } from "AtomicUtils/environment"
import fetchAPI from "AtomicUtils/fetchAPI"
import cookieHandler from "AtomicUtils/cookieHandler"
import styles from "./Price.less"
import { P, H5, A, StarIcon } from "AtomicComponents";
import { Disclaimer } from "AtomicContainers";

class Price extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      locationState: ""
    }
  }

  componentDidMount() {
    this.updatePrice()

    WINDOW.addEventListener(
      "POSTCODE_UPDATE",
      () => this.updatePrice(),
      false
    )
  }

  // getPrice = async () => {
  //   const { api, nameplate } = this.props
  //   const locationState = new cookieHandler().getCookie("state")

  //   if (locationState) {
  //     await this.setState({
  //       locationState
  //     }, async () => {
  //       await fetchAPI({
  //         method: "POST",
  //         url: api,
  //         body: { nameplate }
  //       })
  //       .then(async (response) => {
  //         const json = await response.json()
  //         const { success, errorMsg, data } = json
  //         if (!success) {
  //           this.setState({
  //             errorMessage: errorMsg,
  //             loading: false
  //           })
  //         } else {
  //           // successful
  //           this.setState({
  //             loading: false,
  //             success: true,
  //             data,
  //             rightItemBasedOnState: data[data.findIndex(priceItem => priceItem.state.toLowerCase() === locationState.toLowerCase())]
  //           })
  //         }
  //       })
  //       .catch((response) => {
  //         this.setState({
  //           errorMessage: response.message || `Failed with status ${response.status}`,
  //           loading: false
  //         })
  //       })
  //     })
  //   }
  // }

  updatePrice() {
    const { data } = this.props;
    //const locationState = new cookieHandler().getCookie("state")
    const locationState = 'ACT';

    if (data && locationState) {
      this.setState({
        locationState,
        rightItemBasedOnState: data[data.findIndex(priceItem => priceItem.state.toLowerCase() === locationState.toLowerCase())]
      })
    }
  }

  render() {
    const { white = true } = this.props
    const { locationState, rightItemBasedOnState } = this.state

    if (!locationState || !rightItemBasedOnState) return null

    return (
      <div className={classnames({
        [styles.Price]: true,
        [styles.PriceWhite]: white
      })}>
        <P white={white} withoutMargin>
          {rightItemBasedOnState.disclaimerCode ? `${rightItemBasedOnState.disclaimerCode} from` : 'From'}&nbsp;
          <A
            withoutStyle
            onClick={(event) => {
              if (event && event.target && event.target.querySelector('button')) {
                event.target.querySelector('button').click()
              }
            }}>
            <span className={classnames({
              [styles.PriceText]: true
            })}>
              ${rightItemBasedOnState.lowestPrice.toLocaleString()}<Disclaimer Icon={StarIcon}>{rightItemBasedOnState.disclaimer}</Disclaimer>
            &nbsp;-&nbsp;
              ${rightItemBasedOnState.highestPrice.toLocaleString()}<Disclaimer Icon={StarIcon}>{rightItemBasedOnState.disclaimer}</Disclaimer>
            </span>
          </A>
        </P>
      </div>
    )
  }
}

export default Price



// WEBPACK FOOTER //
// ./src/AtomicContainers/Price/Price.jsx